<template>
  <div class="video-content">
    <div class="video-close">
      <img
        class="video-close-img"
        @click="handleGoBack"
        src="@/assets/img/test/close.png"
      />
    </div>
    <div class="video-person">
      <img src="@/assets/img/avator.png" class="person-img" />
      <div class="person-box">
        <div>讲师：{{ courseData.fullName }}</div>
        <div>{{ courseData.schoolName }}</div>
      </div>
    </div>
    <VideoList
      v-for="(item, index) in courseData.artCourseChapterDtos"
      :key="index"
      :data="item"
    />
    <div class="video-recommend">
      <h5>推荐</h5>
      <div class="recommend-box-wrap">
        <div class="recommend-box" v-for="item in list" :key="item.id">
          <div class="img-wrap">
            <img :src="item.imageUrl" class="box-img" />
            <span>{{ setTime(item.courseTime) }} </span>
          </div>
          <div class="box-title">{{ item.title }}</div>
          <div class="box-desc">讲师：{{ item.fullName }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VideoList from "./VideoList.vue";
import { mapState } from "vuex";
import { expertTank } from "@/api/CourseCenter";
export default {
  name: "VideoContent",
  components: {
    VideoList,
  },
  props: {
    teacherId: [String, Number],
  },
  data() {
    return {
      list: [],
    };
  },
  computed: {
    ...mapState({
      courseData: (state) => state.courseData,
    }),
  },
  watch: {
    teacherId: {
      handler(newVal) {
        if (!newVal) return;
        this.expertTankFunc(newVal);
      },
    },
  },
  methods: {
    expertTankFunc(id) {
      expertTank(id)
        .then((res) => {
          console.log("666", res);
          this.list = res.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    handleGoBack() {
      this.$router.go(-1);
    },
    setTime(time, flag = false) {
      let m = parseInt((time / 60) % 60);
      m = m < 10 ? "0" + m : m;
      let s = parseInt(time % 60);
      s = s < 10 ? "0" + s : s;
      let str = `${m}:${s}`;
      if (flag) {
        str = `${m}分${s}秒`;
      }
      return str;
    },
  },
};
</script>

<style lang="scss">
.video-content {
  .video-close {
    height: 20px;
    margin: 6px 2px 18px 0;
    .video-close-img {
      width: 20px;
      height: 20px;
      float: right;
    }
  }
  .video-person {
    margin-bottom: 39px;
    display: flex;
    justify-content: left;
    .person-img {
      width: 65px;
      height: 65px;
      border-radius: 50%;
      margin-right: 20px;
    }
    .person-box {
      padding-top: 16px;
      & > div {
        line-height: 14px;
        font-size: 14px;
        color: #aaa;
        margin-bottom: 10px;
      }
    }
  }
  .video-recommend {
    h5 {
      margin-top: 100px;
      line-height: 65px;
      font-size: 15px;
      color: #fff;
    }
    .recommend-box-wrap {
      width: 100%;
      display: flex;
      justify-content: left;
      flex-wrap: wrap;
      .recommend-box {
        margin-right: 10px;
        width: 133px;
        .img-wrap {
          position: relative;
          .box-img {
            width: 133px;
            height: 75x;
          }
          span {
            font-size: 12px;
            color: #fff;
            position: absolute;
            right: 3px;
            bottom: 5px;
          }
        }
      }
      .recommend-box:nth-of-type(3n) {
        margin-right: 0;
      }
      .box-title {
        line-height: 13px;
        font-size: 13px;
        color: #fff;
        margin: 10px 0 13px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
      .box-desc {
        line-height: 12px;
        font-size: 12px;
        color: #7f7f7f;
        margin-bottom: 30px;
      }
    }
  }
}
</style>
